import { STATUSES } from '@/constants/common/message.constants'

import { type TruckModelImportJobExEntity } from '../../aspida/@types'

/**
 * 車種取込ステータス
 */
export type TruckModelImportJobStatusType =
  TruckModelImportJobExEntity['status']

export const TRUCK_MODEL_IMPORT_JOB_STATUS_TYPE = {
  /** 取込待ち */
  PENDING: 'PENDING',
  /** 取込中 */
  IMPORTING: 'IMPORTING',
  /** 完了 */
  COMPLETED: 'COMPLETED',
  /** エラー */
  ERROR: 'ERROR'
} as const satisfies Record<
  TruckModelImportJobStatusType,
  TruckModelImportJobStatusType
>

export const TRUCK_MODEL_IMPORT_JOB_STATUS_TYPE_LABEL = {
  [TRUCK_MODEL_IMPORT_JOB_STATUS_TYPE.PENDING]: STATUSES.PENDING,
  [TRUCK_MODEL_IMPORT_JOB_STATUS_TYPE.IMPORTING]: STATUSES.PROCESSING,
  [TRUCK_MODEL_IMPORT_JOB_STATUS_TYPE.COMPLETED]: STATUSES.COMPLETED,
  [TRUCK_MODEL_IMPORT_JOB_STATUS_TYPE.ERROR]: STATUSES.FAILED
} as const satisfies Record<TruckModelImportJobStatusType, string>
